module.exports = __webpack_public_path__ + "static/img/title.b880673.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/news2/title.png
// module id = XgvL
// module chunks = 7